import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeftIcon } from 'lucide-react';
import { useLocale } from '../contexts/LocaleContext';
interface PageHeaderProps {
  title: string;
  subtitle?: string;
  showBack?: boolean;
  action?: React.ReactNode;
}
export function PageHeader({
  title,
  subtitle,
  showBack = false,
  action
}: PageHeaderProps) {
  const navigate = useNavigate();
  const {
    t
  } = useLocale();
  return <header className="flex items-start gap-2 px-2 pb-2 pt-3" data-id="element-1193" data-mp="2yqgf2u1hxlqi">
      {showBack && <button type="button" onClick={() => navigate(-1)} aria-label={t('common.back')} className="-ml-1 grid h-11 w-11 shrink-0 place-items-center rounded-pill text-deep transition-colors duration-150 ease-brand hover:bg-sand-deep" data-id="element-1194" data-mp="2ts6do1p6howg">
          <ChevronLeftIcon size={20} data-id="element-1195" data-mp="2fyf5oxr3id2u" />
        </button>}
      <div className="min-w-0 flex-1" data-id="element-1196" data-mp="2b0dm8bprcbqu">
        <h1 className="text-title text-deep" data-id="element-1197" data-mp="2azb00h3dqxh9">{title}</h1>
        {subtitle && <p className="mt-[2px] text-[12px] leading-snug text-muted" data-id="element-1198" data-mp="2hzroqk5qd0o7">{subtitle}</p>}
      </div>
      {action}
    </header>;
}